// Misc
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

// Atoms
import Container from 'atoms/Container';
import Typography from 'atoms/Typography';

// Components
import Helmet from 'components/Helmet';
import Header from 'components/Header';

// Styles
import styles from './styles';

@withStyles(styles)
export default class OnboardingSuccess extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Helmet />
        <Header />

        <div className={classes.root}>
          <Container>
            <Typography type="display2">
              Thanks! We will contact you soon!
            </Typography>
          </Container>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Onboarding/Success/index.js